export default __webpack_public_path__ + "static/media/add-to-playlist-yellow.1898629c.svg";